import styled from "styled-components";

export const ContainerHeader = styled.div`
    width: 92.5%;
    max-width: 650px;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: space-between;

    margin: 0 auto;

    text-align: center;

    button {
        font-size: 12px;
        font-weight: 600;

        padding: 8px 15px;
        
        border-radius: 4px;
        
        background-color: var(--grey-3);
        color: var(--grey-0);

        transition: 0.4s;

        &:hover {
            background-color: var(--grey-2);
        }
    }
`

export const Header = styled.header`
    width: 100%;
    height: 72px;

    border-bottom: 1px solid var(--grey-3);

    
`

export const ContainerUser = styled.div`
    height: 120px;

    display: flex;
    
    border-bottom: 1px solid var(--grey-3);

    @media (min-width: 500px) {
        height: 100px;
    }

    div {
        width: 92.5%;
        max-width: 650px;

        display: flex;
        flex-direction: column;
        
        margin: auto;
        gap: 20px;
        
        @media (min-width: 500px) {
            flex-direction: row;
            justify-content: space-between;
        }

        h2 {
            font-size: 18px;
            font-weight: 700;

            color: var(--grey-0);
        }

        p {
            font-size: 12px;
            font-weight: 400;

            color: var(--grey-1);
        }
    }
`

export const ContainerInfos = styled.div`
    display: flex;

    @media (min-width: 500px) {
        display: flex;
    }

    div {
        width: 92.5%;
        max-width: 650px;

        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 20px auto;

        h2 {
            font-size: 16px;
            font-weight: 600;
            
            color: var(--grey-0);
        }

        button {
            font-size: 10px;

            padding: 8px ;
            border-radius: 4px;

            background-color: var(--grey-3);
            color: var(--grey-0);

            transition: 0.4s;
         
            &:hover {
            background-color: var(--grey-2);
            }
        }
    }
`

export const Loading = styled.h1`
    width: 100%;

    margin: 40px 0;

    color: var(--grey-0);

    font-size: 20px;

    text-align: center;
`